/* eslint-disable import/no-anonymous-default-export */
import { BlockBlobClient } from "@azure/storage-blob";
import { ENDPOINT, HTTP } from "../config";
import { fetchFromLawfeed } from "../fetchFromLawfeed";

/**
 * @param {string} userId
 * @param {FormData} formData
 */
export default async (userId, formData) => {
    try {
        const pdfFile = formData.get("pdf");
        const pdfName = formData.get("name");
        const parentFolderId = formData.get("parentFolderId");
        const caseId = formData.get("caseId");
        
        const filename = `${pdfName ?? pdfFile.name}.${pdfFile.type.split("/")[1]}`;

        const uploadUrl = 
            await fetchFromLawfeed(
                { 
                    endpoint: ENDPOINT.DOCUMENTS, 
                    routeParams: [userId], 
                    body: {
                        filename, 
                        caption: pdfName, 
                        size: pdfFile.size, 
                        ...(parentFolderId || parentFolderId !== null ? {folderId: parentFolderId} : {}),
                        ...(caseId || caseId !== null ? {caseId} : {})
                    },
                }
            );
        
        const blockBlobClient  = new BlockBlobClient(uploadUrl.sasUrl);
        
        const uploadBlobResponse = await blockBlobClient.upload(pdfFile, pdfFile.size);
        console.log("File uploaded successfully");
        return uploadBlobResponse;
    } catch (error) {
        console.error("Error uploading document:", error);
        throw new Error(error);
    }
}
